
import { useState, useEffect } from 'react';
import { db } from '@/lib/firebase';
import { collection, query, orderBy, onSnapshot, limit } from 'firebase/firestore';

export interface Notice {
    id: string;
    title: string;
    content: string;
    date: string;
    category: string;
    isHot?: boolean;
}

export const useNotices = () => {
    const [notices, setNotices] = useState<Notice[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const q = query(
            collection(db, 'announcements'),
            orderBy('createdAt', 'desc'),
            limit(20)
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            if (snapshot.empty) {
                // 초기 공지사항 샘플
                setNotices([
                    { id: '1', title: '코인투캐쉬 정식 서비스 런칭 안내', content: '글로벌 가상자산 에스크로 플랫폼 코인투캐쉬가 정식 오픈했습니다.', date: '2024-02-01', category: '공지', isHot: true },
                    { id: '2', title: '시스템 점검 안내 (02/15)', content: '안정적인 서비스 제공을 위해 시스템 점검이 예정되어 있습니다.', date: '2024-02-05', category: '점검' }
                ]);
            } else {
                const items = snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                    date: doc.data().createdAt?.toDate().toISOString().split('T')[0] || '2024-02-09'
                })) as Notice[];
                setNotices(items);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    return { notices, loading };
};
